<template lang="pug">
	.comment-thread
		.thread
			comment(
				v-for='comment in comments'
				:key='comment.id'
				:comment='comment'
				:length='comments.length'
				:sectionRef='sectionRef'
				:parentState='state'
				:active-comment-path='activeCommentPath'

				@reply='reply'
			)
</template>

<script>
import Comment from './Comment';

export default {
	name : 'comment-thread',

	props : {
		parent : { // Key of parent node. Is root if root level.
			type : String,
		},
		sectionRef : {
			required : true
		},
		increment : {
			type    : Number,
			default : 25
		},
		// To tell the comment thread to load more comments
		parentState : {
			type : String,
		},
		activeCommentPath : {
			type : Array,
		},
	},

	data : () => ( {
		index    : 0,
		comments : [],

		commentsListener : null,

		state : 'loading',

	} ),

	computed : {
		commentsRef() {
			const { parent, sectionRef } = this;

			if ( !sectionRef || !parent ) {
				return null;
			}

			return sectionRef.collection( 'comments' )
				.where( 'replyingTo', '==', parent )
				.orderBy( 'createdAt', 'desc' );
		}

	},

	watch : {
		commentsRef : {
			immediate : true,
			handler( ref ) {

				if ( !ref ) {
					this.reset();
					return;
				}

				this.reset();
				this.loadMore();

			}
		},

		comments( comments ) {
			this.$emit( 'update-thread-length', comments.length );
		},

		state( state ) {
			this.$emit( 'update-state', state );
		},

		parentState( state ) {

			if ( state === 'loading' ) {
				this.loadMore();
			}

		},
	},

	methods : {

		loadMore() {
			const { increment, commentsRef } = this;

			if ( this.commentsListener ) {
				this.commentsListener();
			}

			this.index += increment;

			this.state = 'loading';

			this.commentsListener = commentsRef
				.limit( this.index )
				.onSnapshot( ( querySnapshot ) => {

					const comments = [];

					querySnapshot.forEach( ( doc ) => {
						const comment = { ...doc.data(), id : doc.id };

						comments.push( comment );
					} );

					if ( this.parent !== 'root' ) {
						comments.reverse();
					}

					this.comments = comments;
					this.state = 'loaded';

				} );
		},

		reply( comment ) {
			this.$emit( 'reply', comment );
		},

		reset() {

			if ( this.commentsListener ) {
				this.commentsListener();
			}

			this.index            = 0;
			this.comments         = [];
			this.commentsListener = null;
			this.replyThreadKey   = {};
		},

	},

	components : {
		Comment
	}

};
</script>

<style lang="scss">

.comment-thread {
	padding: 15px;

	.comment-thread {

		.thread {

			.comment {
				padding-left: 20px;
				position: relative;

				&::before {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					height: calc( 100% + 4px );
					width: 2px;
					background: $alternateGrey;
					border-radius: 50px;
				}
			}
		}
	}
}
</style>
